import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '@app/api/fetchBaseQuery';

import type {
    GetHTMLParsingRulesRequest,
    GetHTMLParsingRulesResponse,
    SetHTMLParsingRulesRequest,
    UpdateQAChecksSettingsRequest,
    UpdateQAChecksSettingsResponse,
} from './types';

const settingsApi = createApi({
    reducerPath: 'lokaliseInternal_settings',
    baseQuery: fetchBaseQuery(),

    endpoints: (builder) => ({
        updateQAChecksSettings: builder.mutation<UpdateQAChecksSettingsResponse, UpdateQAChecksSettingsRequest>({
            query: ({ projectId, values }) => ({
                method: 'PUT',
                url: `/settings/${projectId}/qa-checks`,
                body: values,
            }),
        }),
        getHTMLParsingRules: builder.query<GetHTMLParsingRulesResponse, GetHTMLParsingRulesRequest>({
            query: ({ projectId }) => ({
                method: 'GET',
                url: `/settings/${projectId}/html/`,
            }),
        }),
        getHTMLParsingDefaultRules: builder.query<GetHTMLParsingRulesResponse, GetHTMLParsingRulesRequest>({
            query: ({ projectId }) => ({
                method: 'GET',
                url: `/settings/${projectId}/html/default`,
            }),
        }),
        setHTMLParsingRules: builder.mutation<void, SetHTMLParsingRulesRequest>({
            query: ({ projectId, rules }) => ({
                method: 'PUT',
                url: `/settings/${projectId}/html/`,
                body: { rules },
            }),
        }),
    }),
});

export const {
    useUpdateQAChecksSettingsMutation,
    useGetHTMLParsingRulesQuery,
    useSetHTMLParsingRulesMutation,
    useGetHTMLParsingDefaultRulesQuery,
    useLazyGetHTMLParsingDefaultRulesQuery,
} = settingsApi;

export default settingsApi;
